export default function formatCep(cep: string): string {
  if (!cep) {
    return "";
  }

  if (cep.length !== 8) {
    return cep;
  }

  return cep.replace(/[^\d]+/g, "").replace(/^(\d{5})(\d{3})/, "$1-$2");
}
